<template>
    <div class="main">
        <header id="initiate_header">
            <div class="left">
                <div class="breadcrumb">
                    <a href="javascript:void(0);" class="cursor-pointer" @click.stop="goBack">ACP项目管理</a>
                    <i class="iconfont icon-a-nestmoreweibo"></i>项目详情审核&编辑
                </div>
            </div>
            <div class="right">
                <div class="btn_list">
                    <el-button type="primary" @click.stop="submitVersion">提交审核</el-button>
                </div>
            </div>
        </header>
        <div class="main-wrap">
            <ContentEditor ref="editor" v-model="state.value" :sourceTop="state.sourceTop" :acpToken="acpToken" :placeholder="state.placeholder" :toolbar="state.toolbar" :env="env" />
        </div>
    </div>
</template>
<script setup>
    import { computed, reactive } from 'vue'
    import { getProjectDetailByVersion, submit_version } from '@/api/editor'
    import { useStore } from 'vuex'
    import { useRoute } from 'vue-router'
    import tools from '@/utils/tools.js'

    const route = useRoute()
    const store = useStore();
    const pro_id = computed(() =>
        store.getters.editor_pro_id
    )
    const version_id = computed(() =>
        store.getters.version_id
    )
    const acpToken = computed(() =>
        store.getters.acp_token
    )
    const env = computed(() =>
        /test/.test(location.host) ? 'test' : ''
    )
    const state = reactive({
        value:'',
        sourceTop:'acp',
        toolbar:"undo redo | formatselect forecolor bold alignleft aligncenter alignright alignjustify outdent indent indent2em bullist numlist | blockquote hr emoticons link image axupimgs media audio code",
    })
    if(pro_id.value && version_id.value){
        getProjectDetailByVersion({pro_id:pro_id.value,version_id:version_id.value}).then(res => {
            if(res.status == 0 && res.data){
                state.value = res.data.content;
            }else{
                tools.confirm(res.message);
            }
        })
    }
    const goBack = () => {
        if(route.query.redirect_url){
            window.location.href = route.query.redirect_url;
        }else{
            window.history.go(-1);
        }
    }
    const submitVersion = () => {
        let option = {
            pro_id:pro_id.value,
            content:state.value.replace(new RegExp('data-w', 'g'), 'old-w')
        }
        submit_version(option).then(res => {
            let status = parseInt(res.status);
            if(status == 0){
                tools.confirm({
                    title:'提示',
                    success:'确定',
                    msg:'项目提交审核成功'
                },() => {
                    goBack();
                });
            }else{
                tools.confirm(res.message);
            }
        })
    }
</script>
<style lang="scss">
.main{
    width:100%;
    border-top: 1px solid #F2F3F3;
    header{
        width:100%;
        min-width:975px;
        height:70px;
        padding:20px 20px 20px 40px;
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1001;
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px solid #F2F3F3;
        display:flex;
        justify-content: space-between;
        align-items:center;
        font-size:16px;
        .left{
            display:flex;
            align-items:center;
            .breadcrumb{
                color: #7A8087;
                font-size: 16px;
                line-height: 16px;
                a{
                    color: #7A8087;
                }
                i{
                    padding: 0 6px;
                }
            }
        }
        .right{
            color:#7A8087;
            display:flex;
            align-items:center;
            .btn_list{
                display:flex;
                align-items:center;
            }
        }
    }
    .main-wrap{
        margin:0 auto;
        padding:107px 60px;
        min-width:904px;
        max-width:1240px;
    }
}
</style>
